import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { CTableStatusOrder } from '../../TablaTypes';

@customElement('app-table-sort-arrows')
export class TableSortArrowsComponent extends LitElement {
    @property({ type: Number, reflect: true }) em_status: CTableStatusOrder = CTableStatusOrder.None;

    static styles = css`
        :host {
            display: inline-flex;
            align-items: center;
            width: 13px;
            height: 13px;
        }

        svg {
            width: 100%;
            height: 100%;
        }

        /* Estado base (None) y animación */
        path {
            fill: #A8A8A8;
            transition: fill 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        :host([em_status="${CTableStatusOrder.Asc}"]) .arrow_desc {
            fill: #484849;
        }

        :host([em_status="${CTableStatusOrder.Desc}"]) .arrow_asc {
            fill: #484849;
        }
    `;

    render() {
        return html`
            <svg viewBox="0 0 100 100" class="order_arrows">
                <path class="arrow_asc" d="M 24.187 7.5 L 39.83 7.5 L 39.83 65.758 L 24.187 65.758 L 24.187 7.5 Z  M 9 65.758 L 32.009 92.5 L 55.017 65.758 L 9 65.758 L 9 65.758 Z"></path>
                <path class="arrow_desc" d="M 75.83 92.5 L 60.187 92.5 L 60.187 34.242 L 75.83 34.242 L 75.83 92.5 Z  M 91.017 34.242 L 68.009 7.5 L 45 34.242 L 91.017 34.242 L 91.017 34.242 Z"></path>
            </svg>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'app-table-sort-arrows': TableSortArrowsComponent;
    }
}